import AxiosInstance from './AxiosInstance';
import { constructFilter, constructParameters } from '../../utils/APIUtils';
import { getContentDispositionFilename } from '../../utils/HeaderUtils';

const ApiClient = {
	get(url, params, page, filter, sort) {
		const parameters = constructParameters(page, filter, sort);
		parameters.length > 0 && (url += '?' + parameters);

		let options = {
			method: 'GET',
			url: url,
			params: {
				...params,
			},
		};

		console.info('ApiClient.get() called. ', JSON.stringify(options));
		return this.callAxios(options);
	},

	getBinary(url, params, page, filter, sort) {
		const parameters = constructParameters(page, filter, sort);
		parameters.length > 0 && (url += '?' + parameters);

		let options = {
			responseType: 'blob',
			method: 'GET',
			url: url,
			params: {
				...params,
			},
		};

		console.info(
			'ApiClient.get() called for binary response. ',
			JSON.stringify(options)
		);
		return this.callAxios(options);
	},

	post(url, data) {
		const options = {
			method: 'POST',
			url: url,
			data: data,
		};
		console.info('ApiClient.post() called. ', JSON.stringify(options));
		return this.callAxios(options);
	},

	put(url, data) {
		const options = {
			method: 'PUT',
			url: url,
			data: data,
		};
		console.info('ApiClient.put() called. ', JSON.stringify(options));
		return this.callAxios(options);
	},

	delete(url) {
		const options = {
			method: 'DELETE',
			url: url,
		};
		console.info('ApiClient.delete() called. ', JSON.stringify(options));
		return this.callAxios(options);
	},

	request(method, url, data, params, responseType) {
		let options = {
			method: method,
			url: url,
			data: data,
			responseType: responseType,
			params: {
				...params,
			},
		};

		console.info('ApiClient.request() called. ', JSON.stringify(options));
		return this.callAxios(options);
	},

	getFile(url, download = true) {

		let options = {
			method: 'GET',
			url: url,
			responseType: 'blob',
		};

		return this.callAxios(options).then(function (response) {
			if(!download) {
				return response;
			}

			const link = document.createElement('a');

			const url = URL.createObjectURL(response.data);
			link.setAttribute('href', url);

			const fileName = getContentDispositionFilename(response.headers);
			link.setAttribute('download', fileName);

			link.click();
		});
	},

	callAxios(options) {
		return new Promise((resolve, reject) => {
			AxiosInstance.request(options)
				.then((response) => resolve(response))
				.catch((error) => reject(error));
		});
	},
};

export default ApiClient;
